import {
  OPERATIONS,
  NETWORK,
  TASK,
  FLEET,
  RATE,
  PRICING,
  FINANCE,
  ACCOUNT,
  PAYOUT,
  ANALYTICS,
  AUTOMATION,
  ROLZOLOCATIONS,
  SUPPORT,
} from '../actions'

//load tabs state from local storage
const getTabs = localStorage.getItem('tabs')
const INITIAL_STATE = getTabs
  ? JSON.parse(getTabs)
  : {
      task: false,
      operations: false,
      network: false,
      fleet: false,
      pricing: false,
      rates: false,
      finance: false,
      account: false,
      payouts: false,
      automation: false,
      analytics: false,
      rolzoLocations: false,
      support: false,
    }

export default (state = INITIAL_STATE, action) => {
  //store new state in localStorage (to retain the new state after refreshing the page)
  switch (action.type) {
    case TASK:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, task: !state.task })
      )
      return {
        ...state,
        task: !state.task,
      }
    case OPERATIONS:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, operations: !state.operations })
      )
      return {
        ...state,
        operations: !state.operations,
      }
    case NETWORK:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, network: !state.network })
      )
      return {
        ...state,
        network: !state.network,
      }
    case FLEET:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, fleet: !state.fleet })
      )
      return {
        ...state,
        fleet: !state.fleet,
      }
    case RATE:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, rates: !state.rates })
      )
      return {
        ...state,
        rates: !state.rates,
      }
    case PRICING:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, pricing: !state.pricing })
      )
      return {
        ...state,
        pricing: !state.pricing,
      }
    case FINANCE:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, finance: !state.finance })
      )
      return {
        ...state,
        finance: !state.finance,
      }
    case ACCOUNT:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, account: !state.account })
      )
      return {
        ...state,
        account: !state.account,
      }
    case PAYOUT:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, payouts: !state.payouts })
      )
      return {
        ...state,
        payouts: !state.payouts,
      }
    case ANALYTICS:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, analytics: !state.analytics })
      )
      return {
        ...state,
        analytics: !state.analytics,
      }
    case AUTOMATION:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, automation: !state.automation })
      )
      return {
        ...state,
        automation: !state.automation,
      }
    case ROLZOLOCATIONS:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, rolzoLocations: !state.rolzoLocations })
      )
      return {
        ...state,
        rolzoLocations: !state.rolzoLocations,
      }
    case SUPPORT:
      localStorage.setItem(
        'tabs',
        JSON.stringify({ ...state, support: !state.support })
      )
      return {
        ...state,
        support: !state.support,
      }
    default:
      return state
  }
}
